"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scanner = void 0;
const Token_1 = require("./Token");
const ROW_DELIMITER = /((?:\r\n)|\n|\r)/;
class Scanner {
  constructor(args) {
    this.cursor = 0;
    this.line = args.line;
    this.lineLength = this.line.length;
    this.parserOptions = args.parserOptions;
    this.hasMoreData = args.hasMoreData;
    this.cursor = args.cursor || 0;
  }
  get hasMoreCharacters() {
    return this.lineLength > this.cursor;
  }
  get nextNonSpaceToken() {
    const {
      lineFromCursor
    } = this;
    const regex = this.parserOptions.NEXT_TOKEN_REGEXP;
    if (lineFromCursor.search(regex) === -1) {
      return null;
    }
    const match = regex.exec(lineFromCursor);
    if (match == null) {
      return null;
    }
    const token = match[1];
    const startCursor = this.cursor + (match.index || 0);
    return new Token_1.Token({
      token,
      startCursor,
      endCursor: startCursor + token.length - 1
    });
  }
  get nextCharacterToken() {
    const {
      cursor,
      lineLength
    } = this;
    if (lineLength <= cursor) {
      return null;
    }
    return new Token_1.Token({
      token: this.line[cursor],
      startCursor: cursor,
      endCursor: cursor
    });
  }
  get lineFromCursor() {
    return this.line.substr(this.cursor);
  }
  advancePastLine() {
    const match = ROW_DELIMITER.exec(this.lineFromCursor);
    if (!match) {
      if (this.hasMoreData) {
        return null;
      }
      this.cursor = this.lineLength;
      return this;
    }
    this.cursor += (match.index || 0) + match[0].length;
    return this;
  }
  advanceTo(cursor) {
    this.cursor = cursor;
    return this;
  }
  advanceToToken(token) {
    this.cursor = token.startCursor;
    return this;
  }
  advancePastToken(token) {
    this.cursor = token.endCursor + 1;
    return this;
  }
  truncateToCursor() {
    this.line = this.lineFromCursor;
    this.lineLength = this.line.length;
    this.cursor = 0;
    return this;
  }
}
exports.Scanner = Scanner;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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